<svelte:head>
  <link rel="canonical" href="https://xn--80aaaa1bcaqfbqcckfp8c4cxgsc.xn--p1ai{currentUrl}" />
</svelte:head>

<script lang="ts">
  import { onMount, setContext } from 'svelte';
  import * as Sentry from '@sentry/sveltekit';
  import {
    authModal,
    feedbackModal,
    deviceWidth,
    JwtStore,
    UserStore,
    restoreModal,
		languageModal
  } from '$lib/stores';
  import AuthModal from '$lib/components/auth_modal/AuthModal.svelte';
  import RestoreModal from '$lib/components/restore_password/RestoreModal.svelte';
  import FeedbackModal from '$lib/components/feedback_modal/FeedbackModal.svelte';
  import LanguageModal from '$lib/components/language_modal/LanguageModal.svelte';
  import CookieModal from '$lib/components/cookie_modal/CookieModal.svelte';
  import VictoryBanner from '$lib/components/victory_day_banner/VictoryBanner.svelte';
  import Toast from '$lib/components/toast/Toast.svelte';
  import Actions from '$lib/components/actions/Actions.svelte';
  import { page } from '$app/stores';
  import '../app.postcss';
  import '$lib/assets/styles/style.css';

  import { browser } from '$app/environment';
  import { chatNotify, connect } from '$lib/services/websocket/chat_ws';
  import { ChatsApi } from '$lib/services/chats';
  // ПЕРЕНЕСЕНО В profile/(app)
  // import {connect} from '$lib/services/websocket/chat_ws';
  $: currentUrl = $page.url.pathname; // Full URL of the current page

  export let data;

  /*
  При инициализации страницы (как сервер так клиент-сайд)
  мы получаем JWT и устанавливаем его в $svelte/store  (это не storage!)
  Делаем это на самом главном layout чтобы токен (если он есть - был доступен на всех страницах/компонентах через store)
   */
  if (browser) {
    JwtStore.update(() => {
      return data.JWT as string;
    });
    UserStore.update(() => {
      return data.user;
    });
  }

  /* чтобы было проще получать данные о токене / текущем пользователе в компонентах
    сохраним их в контекст
   */
  setContext('JWT', data.JWT as string);
  setContext('CURRENT_USER', data.user);
  Sentry.setUser(data.user);
  /*
   * ПЕРЕНЕСЕНО В profile/(app)
   *  Стартуем веб-сокет сервер (singleton)
   */
  // if (browser) {
  //   connect(data.JWT as string);
  // }
  /**
   * подписываемся на нотификацию о новых сообщениях
   */
  if (browser) {
    connect(data.JWT as string);
  }


  const getUnreadMessages = async () => {
    // here set store
    console.log('get chat unread messages from layout');
    const { data } = await ChatsApi().getChatUnreadMessages();

    if (data?.countAllUnreadMessages || data?.countAllUnreadMessages === 0) {
      console.log('set user store unread messages');
      UserStore.update((currentUser) => ({
        ...currentUser,
        quantityUnreadMessages: data?.countAllUnreadMessages
      }));
    }
  }

  chatNotify(async (_) => {
    getUnreadMessages();
  });

  onMount(()=>{
    getUnreadMessages();
  });
</script>
<VictoryBanner />
<Toast />

{#if $deviceWidth >= 1366}
  <Actions />
{/if}

<slot />

{#if $authModal}
  <AuthModal bind:show={$authModal} />
{/if}

{#if $restoreModal}
  <RestoreModal bind:show={$restoreModal} />
{/if}

{#if $feedbackModal}
  <FeedbackModal bind:show={$feedbackModal} on:close={() => feedbackModal.set(false)} />
{/if}

{#if $languageModal !== null}
  <LanguageModal />
{/if}

  <CookieModal />

<svelte:window bind:innerWidth={$deviceWidth} />
